<template>
<div id="app">
    <notifications></notifications>
    <router-view />
</div>
</template>

<script>
import configPOPTheme from '@/config/POPTheme'

export default {
    name: 'POPSHIPPOP',
    data() {
        return {
            color: "vue", //vue|blue|orange|green|red|primary
            userLogin: "",
            createdBy: ""
        };
    },
    metaInfo: {
      title: configPOPTheme.webTitle || 'POP SHIPPOP',
      titleTemplate: '%s'
    },
    created() {
        //在页面刷新时将vuex里的信息保存到localStorage里
        window.addEventListener("beforeunload", () => {
            localStorage.setItem("messageStore", JSON.stringify(this.$store.state));
        });

        //在页面加载时读取localStorage里的状态信息
        localStorage.getItem("messageStore") &&
        this.$store.replaceState(
            Object.assign(
                this.$store.state,
                JSON.parse(localStorage.getItem("messageStore"))
            )
        );
        setTimeout(() => {
            localStorage.removeItem("messageStore");
        }, 100);
    }
}
</script>
